import callApiAxiosClient from "../../axios/axios_client";
import { userItemList } from "../../models";


async function getUsers(): Promise<userItemList> {
    const token = JSON.parse(localStorage.getItem('user')!)
    const authorization = 'Bearer ' + token.token
    return callApiAxiosClient<userItemList>({
        method: "get",
        url: "usersactions/users",
        headers: {
            "Content-Type": "Application/json",
            "Authorization": authorization
        }
    })
}
export default getUsers;